import type { FC } from 'react'

import { EndCall } from '@liveHelper/assets/EndCall'
import {
  callDataSelector,
  useStore,
  visitorPrivateActionsSelector,
} from '@liveHelper/models/store'
import { ActionButton } from '@oneToOne/shared/styles'

import { useContextTranslation } from '@core/i18n'

interface EndCallButtonProps {
  isMinimized?: boolean
  terminateCallType?: 'endOngoingCall' | 'stopDialing'
}

/**
 * EndCallButton Component
 *
 * A button component for ending a call.
 */
export const EndCallButton: FC<EndCallButtonProps> = ({
  isMinimized,
  terminateCallType = 'endOngoingCall',
}) => {
  const { t } = useContextTranslation()
  const { terminateCall } = useStore(visitorPrivateActionsSelector)
  const callData = useStore(callDataSelector)

  return (
    <ActionButton
      aria-label={t(`oneToOne:End call`)}
      shape="circle"
      actionType="danger"
      buttonSize={isMinimized ? 'md' : 'lg'}
      onClick={() => {
        terminateCall?.({
          agentId: callData?.agentId,
          type: terminateCallType,
        })
      }}
      icon={
        <EndCall
          width={isMinimized ? '18px' : '26px'}
          fill="var(--white)"
          label="end call"
        />
      }
    />
  )
}
